import React, { ComponentType, FunctionComponent, useContext } from "react";
import { Subtract } from "utility-types";
import { TranslationContext } from "./TranslationContext";
import { IWithTranslatorProps } from "./IWithTranslatorProps";

export function WithTranslator<P extends IWithTranslatorProps>(
  Component: ComponentType<P>
): FunctionComponent<Subtract<P, IWithTranslatorProps>> {
  function ComponentWithTranslator(props: Subtract<P, IWithTranslatorProps>) {
    const translator = useContext(TranslationContext);
    return <Component {...(props as P)} translator={translator} isTranslatorReady={translator?.isReady ?? false} />;
  }

  const componentName = Component.displayName ?? Component.displayName ?? `Component`;
  ComponentWithTranslator.displayName = `WithTranslator(${componentName})`;

  return ComponentWithTranslator;
}
